<template>
    <div>
        <card-header title="Registrations" :subheader="type" icon="fa-users"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-communicate', {confId: conference.id, type: commType}, card)"><i class="far fa-comment"></i>Communicate</button>
            <button @click="exportRegistrations()"><i class="far fa-file-excel"></i>Export</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <subheader-list-item title="Registrations" icon="fa-users"/>
                <registration-tile
                    :card="card"
                    :registration="reg"
                    v-for="reg in registrations"
                    @click="$openCard('registration', {regId: reg.id, confId: reg.conference_id}, card)"
                    :active="(child && child.definition.component === 'registration' && reg.id === parseInt(child.props.regId))"
                />
            </card-list>
            <infinite-loading @infinite="loadRegistrations">
                <div slot="no-more"></div>
                <div slot="no-results">No Records Found</div>
            </infinite-loading>
        </card-body>

        <card-footer>
            Showing <strong>{{ registrations.length | numeral('0,0') }}</strong> <span v-if="paging.count !== paging.total"> of <strong>{{ paging.count | numeral('0,0') }}</strong> {{ type }} </span>of <strong>{{ paging.total | numeral('0,0') }}</strong> Total Registrations
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import CardList from "@/TIER/components/CardList";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";


    import {client as http, apiUrl} from "@/http_client";
    import ConferenceTile from "../../../components/tiles/ConferenceTile";
    import RegistrationTile from "../../../components/tiles/RegistrationTile";
    import Login from "../../../views/Login";
    import CardToolbar from "../../../TIER/components/CardToolbar.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {CardToolbar, RegistrationTile, ConferenceTile, CardFooter, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem},
        data() {
            return {
                registrations: [],
                type: '',
                paging: {
                    total: 0,
                    start: 0,
                    count: 0
                },
                apiUrl: apiUrl,
            };
        },
        computed: {
            commType() {
                switch (this.props.type) {
                    case 'all':
                        return 'all'
                    case 'complete':
                        return 'complete'
                    case 'pending':
                        return 'pending'
                    case 'cc':
                        return 'cc'
                    case 'po':
                        return 'po'
                    case 'access':
                        return 'access'
                    default:
                        return 'sess' + this.type;
                }
            }
        },
        methods: {
            loadRegistrations: function($state) {
                http.get(`registrations/conf/${this.props.confId}/${this.props.type}/${this.paging.start}/500`, { force: true }).then(response => {
                    this.registrations.push(...response.data.registrations);
                    this.paging.total = response.data.total;
                    this.paging.count = response.data.count;
                    this.paging.start += response.data.registrations.length;

                    if ($state) $state.loaded();

                    if ($state && response.data.count <= this.registrations.length) {
                        $state.complete();
                    }
                })
            },
            loadAgain: function() {
                this.registrations = [];
                this.paging = {
                    total: 0,
                    start: 0,
                    count: 0
                };

                this.loadRegistrations();

                switch (this.props.type) {
                    case 'all':
                        this.type = 'All Registrations';
                        this.$emit('title', 'All Registrations');
                        break;
                    case 'complete':
                        this.type = 'Complete Registrations';
                        this.$emit('title', 'Complete Registrations');
                        break;
                    case 'pending':
                        this.type = 'Pending Registrations';
                        this.$emit('title', 'Pending Registrations');
                        break;
                    default:
                        this.type = null;
                }
            },
            exportRegistrations: function() {
                http.get(`${this.apiUrl}registrations/export/${this.props.confId}/${this.props.type}`).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'registrations.csv');
                    document.body.appendChild(link);
                    link.click();
                }).catch(error => {
                    console.log(error);
                    // if error is 404
                    if (error.response.status === 404) {
                        window.alert('No registrations to export');
                        return;
                    } else {
                        window.alert('Error exporting registrations');
                        return;
                    }
                });
            },
            reload: function() {
                console.log('Reloading registrations');
                this.loadAgain();
            }
        },
        watch: {
            'props.type': function() {
                this.type = this.props.type;
                this.loadAgain();
            }
        },
        mounted: function() {
            console.log(this.apiUrl)
            console.log(`${this.apiUrl}registrations/export/${this.props.confId}/${this.props.type}`)
        }
    };
</script>
